import { AsyncSelect, SelectInstance, SelectOption } from '@cimplico/components';
import { Ref, useEffect, useState } from 'react';
import { useProcedureTemplates } from '../../queries/use-procedure-templates';

type ProcedureTemplateSelectProps = {
    defaultTemplate?: string | null;
    title?: string;
    isOptional?: boolean;
    isMulti?: boolean;
    placeholder?: string;
    form?: string;
    errorMessage?: string;
    isDisabled?: boolean;
    onChange: (id?: string) => void;
    innerRef?: Ref<SelectInstance>;
};

function ProcedureTemplateSelect({
    defaultTemplate,
    title,
    isMulti = false,
    isOptional = false,
    placeholder,
    form,
    onChange,
    isDisabled,
    errorMessage,
    innerRef,
}: ProcedureTemplateSelectProps): JSX.Element {
    const [templateSearch, setTemplateSearch] = useState('');
    const templateQuery = useProcedureTemplates({ search: templateSearch });
    const [selected, setSelected] = useState<string | undefined | null>(defaultTemplate);

    const isLoading = templateQuery.isFetching || templateQuery.isLoading;

    function handleTemplateChange(options: SelectOption[]): void {
        setSelected(options.map((o) => o.value as string)[0]);
        onChange(options.map((o) => o.value as string)[0]);
    }

    useEffect(() => {
        if (selected === undefined) {
            const defaultTemplateId = templateQuery.data?.procedureTemplates.find((pt) => pt.default === true)?.id as string;
            setSelected(defaultTemplateId);
            onChange(defaultTemplateId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateQuery.data?.procedureTemplates]);

    return (
        <AsyncSelect
            placeholder={placeholder || 'Select a template...'}
            title={title}
            form={form}
            isOptional={isOptional}
            isMulti={isMulti}
            isDisabled={isDisabled}
            errorMessage={isLoading ? undefined : errorMessage}
            isLoading={isLoading}
            options={(templateQuery.data?.procedureTemplates || []).map((i) => ({
                value: i.id,
                label: i.name,
                isSelected: selected === i.id,
            }))}
            onSearch={setTemplateSearch}
            onChange={(options): void => {
                handleTemplateChange(options);
            }}
            ref={innerRef}
        />
    );
}

export default ProcedureTemplateSelect;
